import React from 'react';
import {FLIP_LOADER} from 'utils/constants';
 
class Loader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {show: !!this.props.inline,counter:0};
        this.toggleLoader = this.toggleLoader.bind(this);    
        //app.events.subscribe({[FLIP_LOADER] : this.toggleLoader},this,-1);
        this.initEvents();
        this.counter = 0;
        //console.log('loader init');
    }
    initEvents(){
        if(!this.props.inline && !this.eventInited && app.events){
            app.events.subscribe({[FLIP_LOADER] : this.toggleLoader},this,-1);
            this.eventInited = true;
            //console.log('initEvent');
        }
    }
    componentDidUpdate(){
        this.initEvents();
        //console.log('loader update');
    }
    toggleLoader([params]){
        //params = params && params.constructor == Array?params[0]:params;
        //let{counter} = this.state;
        let counter = this.counter;
        //console.log(counter+' oc ' +this.state.counter + ' ' +params.status);
        if(params.reset){
            counter = 0;
        }
        if(params.status){
            counter++;
        }
        else{
            counter--;
        }
        if(counter<0){
            counter = 0;
        }
        let status = counter > 0;
        this.counter = counter;
        //console.log('reset>'+params.reset+' - '+counter + ' status '+status+' -org-'+params.status);
        this.setState({show: status,counter});
    }

    /*static getDerivedStateFromProps(nextProps, prevState) {
        let inline = !!nextProps.inline;
        console.log(prevState.counter+' derived state> '+inline);
        return inline?{show: inline}:{show: prevState.counter >0};
    }*/
    
    render(){
        return(
            <React.Fragment>
                {!this.state.show && <React.Fragment/>}
                {this.state.show && <div className="bg-loader">
                                            <div className="loader"></div>
                                        </div>}
            </React.Fragment>
            // <div className={this.props.class}>               
            // </div>
        )
    }
}
export default Loader;